// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import {
	Breadcrumb,
	Button,
	Card,
	Col,
	Offcanvas,
	Row,
	Tab
} from 'react-bootstrap';

// import custom components
import GridListViewButton from 'components/elements/miscellaneous/GridListViewButton';
import OffcanvasAddDepenserecetteForm from '../add-new-depenserecette/OffcanvasAddDepenserecetteForm';
// import sub components
import DepenserecettesListItems from '../all-depenserecettes/DepenserecettesListItems';
import DepenserecetteService from '../../services/DepenserecetteService';

const Depenserecettes = () => {
	const [depenserecettes, setDepenserecettes] = useState([]);
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		DepenserecetteService.getAllDepenserecettes().then((response) => {
			setDepenserecettes(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Bilan{' '}
									<span className="fs-5 text-muted"> ({depenserecettes.length})</span>
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">
										Accueil
									</Breadcrumb.Item>
									<Breadcrumb.Item active>Bilan</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="d-flex align-items-center justify-content-between">

								<div>
									<Button onClick={handleShow}>Ajouter un Bilan</Button>
									<Offcanvas
										show={show}
										onHide={handleClose}
										placement="end"
										name="end"
										style={{ width: '600px' }}
									>
										<Offcanvas.Header closeButton>
											<Offcanvas.Title as="h3">
												Enregistrer un Bilan
											</Offcanvas.Title>
										</Offcanvas.Header>
										<Offcanvas.Body className="pt-0">
											<OffcanvasAddDepenserecetteForm onClick={handleClose} />
										</Offcanvas.Body>
									</Offcanvas>
								</div>
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>

					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								{/* Depenserecettes in list view */}
								<DepenserecettesListItems />
								{/* end of Depenserecettes in list view */}
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default Depenserecettes;
